import FormsTabs from '../components/FormsTabs';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Brieven.css';

const Brieven = () => {
  const [brieven, setBrieven] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => { loadBrieven(); }, []);

  const loadBrieven = async () => {
    try {
      setLoading(true);
      const res = await fetch('/api/brieven', { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) setBrieven(data.brieven || []);
    } catch (err) { console.error('Kon brieven niet laden:', err); }
    finally { setLoading(false); }
  };

  const nieuweBrief = async () => {
    try {
      const res = await fetch('/api/brieven', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ titel: 'Nieuwe brief', html_content: '<p></p>' })
      });
      const data = await res.json();
      if (data.success && data.brief) navigate(`/brieven/${data.brief.id}`);
    } catch (err) { console.error(err); alert('Kon brief niet aanmaken'); }
  };

  const verwijderBrief = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Brief verwijderen?')) return;
    try {
      await fetch(`/api/brieven/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      loadBrieven();
    } catch (err) { console.error(err); }
  };

  const formatDate = (iso) => iso ? new Date(iso).toLocaleString('nl-NL', { dateStyle: 'short', timeStyle: 'short' }) : '';

  const previewText = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    const text = tmp.textContent || tmp.innerText || '';
    return text.length > 100 ? text.slice(0, 100) + '…' : text || '(leeg)';
  };

  return (
    <div className="brieven-page">
      <div className="brieven-header">
        <FormsTabs active="brieven" title="Brieven" />
        <button className="brieven-btn-primary" onClick={nieuweBrief}>+ Nieuwe brief</button>
      </div>
      {loading ? (
        <p className="brieven-loading">Laden…</p>
      ) : brieven.length === 0 ? (
        <div className="brieven-empty">
          <p>Nog geen brieven aangemaakt.</p>
          <p>Klik op <strong>+ Nieuwe brief</strong> om te beginnen.</p>
        </div>
      ) : (
        <div className="brieven-lijst">
          {brieven.map((b) => (
            <div key={b.id} className="brief-rij" onClick={() => navigate(`/brieven/${b.id}`)}>
              <div className="brief-rij-main">
                <div className="brief-titel">{b.titel}</div>
                <div className="brief-preview">{previewText(b.html_content)}</div>
              </div>
              <div className="brief-meta">
                <div className="brief-datum">{formatDate(b.updated_at)}</div>
                <button className="brief-btn-delete" onClick={(e) => verwijderBrief(b.id, e)} title="Verwijderen">🗑</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Brieven;
